import { RadixDialog } from '@/components/RadixDialog';
import { EsyncAlerts, MasterTranslation } from '@/constants';
import { useGlobalState, usePreventBodyScroll } from '@/hooks';
import { useEmailSyncContext } from '@/modules/pmt/context/EmailSync.context';
import { gtmViewEsyncAlerts } from '@/utils';
import { useEffect } from 'react';

export enum ConnectFailedReason {
  CANNOT_CONNECT = 'CANNOT_CONNECT',
  EMAIL_DUPLICATED = 'EMAIL_DUPLICATED',
  MAX_EMAILS_CONNECTED = 'MAX_EMAILS_CONNECTED',
  // Validation error: Include if needed
  // EMAIL_REQUIRED = 'EMAIL_REQUIRED',
}

const GTMAlertMap = {
  [ConnectFailedReason.CANNOT_CONNECT]: EsyncAlerts.ConfigLimitReached,
  [ConnectFailedReason.EMAIL_DUPLICATED]: EsyncAlerts.EmailAlreadyConnected,
  [ConnectFailedReason.MAX_EMAILS_CONNECTED]: EsyncAlerts.MaxEmailsConnected,
};

export const ESConnectFailedDialog = () => {
  const { t } = useGlobalState();
  const { connectEsFailedReason, setConnectEsFailedReason } = useEmailSyncContext();

  const show = !!connectEsFailedReason;

  const onHide = () => setConnectEsFailedReason(null);

  const TRANSLATED_REASON = {
    [ConnectFailedReason.MAX_EMAILS_CONNECTED]: {
      main: t(MasterTranslation.MaxEmailsReachedMain),
      sub: t(MasterTranslation.MaxEmailsReachedSub),
    },
    [ConnectFailedReason.EMAIL_DUPLICATED]: {
      main: t(MasterTranslation.EmailAlreadyConnectedMain),
      sub: t(MasterTranslation.EmailAlreadyConnectedSub),
    },
    [ConnectFailedReason.CANNOT_CONNECT]: {
      main: t(MasterTranslation.UnableConnectEmailMain),
      sub: t(MasterTranslation.UnableConnectEmailSub),
    },
  };

  usePreventBodyScroll(show);

  useEffect(() => {
    if (!connectEsFailedReason || !GTMAlertMap[connectEsFailedReason]) return;

    gtmViewEsyncAlerts({ alert: GTMAlertMap[connectEsFailedReason] });
  }, [connectEsFailedReason]);

  if (!connectEsFailedReason || !TRANSLATED_REASON[connectEsFailedReason]) return null;

  const { main, sub } = TRANSLATED_REASON[connectEsFailedReason];

  return (
    <RadixDialog.WithGraphicWrapper open={show} onOpenChange={onHide}>
      <RadixDialog.Header closeable onClose={onHide} />
      <RadixDialog.Content>
        <RadixDialog.MainText>{main}</RadixDialog.MainText>
        <RadixDialog.SubText>{sub}</RadixDialog.SubText>
      </RadixDialog.Content>
    </RadixDialog.WithGraphicWrapper>
  );
};
